import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IconBuildingSolid } from "../../../../../icon";
import { ActionTablePath } from "../../../action-table/action-table";
import { useGetLocationsQuery } from "../../../../../api/plamo-api";

function LocationList() {
  const navigate = useNavigate()
   
    const isLoading = false;
    
    const columns = useMemo(() => [
      {
        title: "Id",
        dataIndex: "id",
        sorter: true,
        filter: true,
        type: 'int',
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: true,
        filter: true,
        type: 'string',
        render: (value, item) => <Link to={`/location/${item.id}`}>{ value }</Link>
      }
    ], [])
  
    return (
      <div>
        <Breadcrumb
            items={[
              {
                onClick: () => navigate('/'),
                title: <HomeOutlined />,
              },
              {
                title: (
                  <>
                    <IconBuildingSolid />
                    <span>Standorte</span>
                  </>
                ),
              },            
            ]}
          />
        <ActionTablePath
            isParentLoading={isLoading}
            buttonRow={{
              buttons: [
                {
                  text: 'Neu',
                  buttonType: 'primary',
                  onClick: () => navigate('./new')
                },
              ]
            }}
            tableData={{
              defaultSortKey: 'id',
              columns,
              dataSource: {
                pageableQueryEndpoint: useGetLocationsQuery,
                queryResultMapping: (result) => result?.items
              },
              actions: [
                {
                  caption: 'Bearbeiten',
                  onClick: (item) => navigate(`./${item.id}`)
                },
                /*
                {
                  caption: 'Löschen',
                  danger: true,
                  onClick: (item) => deleteEmployee(item)
                }
                  */
              ]
            }}
          />
  
      </div>
    )
}

export default LocationList;